import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import Select from '@/components/DSE/Select';
import FileUpload from '@/components/DSE/FileUpload';
import MDinput from '@/components/MDinput';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      defaultValue: null,
      props: {
        maxlength: 255,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    productGroupID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'printTemplate.productGroup',
        valueField: 'id',
        required: true,
        labelField: 'description',
        loading: vue.$store.getters['productGroup/isLoading'],
        options: vue.$store.getters['productGroup/loadedItems']
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    productTypeID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'common.productType',
        valueField: 'id',
        labelField: 'description',
        loading: vue.$store.getters['productType/isLoading'],
        options: vue.$store.getters['productType/loadedItems']
      }
    },
    printerTypeOption: {
      type: Select,
      props: {
        caption: 'printer.typeOption',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('printerType')
      },
      rules: [{ validator: validatorRequireNumber }]
    },
    domains: {
      type: Select,
      defaultValue: [],
      props: {
        caption: 'printTemplate.domains',
        valueField: 'id',
        labelField: 'name',
        multiple: true,
        loading: vue.$store.getters['domain/isLoading'],
        options: vue.$store.getters['domain/loadedItems']
      }
    },
    documentFileName: {
      type: FileUpload,
      defaultValue: null,
      hideOnCreate: true,
      props: {
        hideOnCreate: true,
        caption: 'printTemplate.templateDocument',
        uploadRoute: 'printtemplate/file',
        deleteAction: 'printTemplate/deleteFile',
        downloadAction: 'printTemplate/downloadFile'
      }
    }
  };
}

const layout = {
  named: false,
  sections: [
    {
      width: 100
    }
  ]
};

export function getLayoutDefinition(vue) {
  return layout;
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
